import { LayoutDashboard, Layers, Truck, LineChart, Users, Receipt, History, Plug, Boxes, Contact, CalendarClock, Fingerprint, CalendarCheck, ListChecks, ClipboardList, ShoppingCart, Link2, Shuffle, Package, BarChart3, PlugZap } from "lucide-react";

// Logical navigation groups. Routes + permission guards are UNCHANGED — this only
// organizes the SAME existing items under labels. `perm` = single key, `anyPerm` = any-of.
export const NAV_GROUPS = [
  {
    label: "Operations",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", perm: "dashboard:view" },
      { to: "/inbound", label: "Inbound Management", icon: Truck, testid: "nav-inbound", anyPerm: ["transit:view", "arrival:pending_view", "arrival:check_view", "arrival:checked_view"] },
      { to: "/task-admin", label: "Task Management", icon: ClipboardList, testid: "nav-task-admin", anyPerm: ["task:view_all", "task:manage"] },
      { to: "/tasks", label: "My Tasks", icon: ListChecks, testid: "nav-my-tasks", perm: "task:view_own" },
    ],
  },
  {
    label: "Inventory",
    items: [
      { to: "/skus", label: "Master SKU", icon: Layers, testid: "nav-skus", perm: "sku:view" },
      { to: "/return-to-rack", label: "Return to Rack", icon: Boxes, testid: "nav-return-to-rack", perm: "sku:view" },
      { to: "/adjust-log", label: "Adjust Log", icon: History, testid: "nav-adjust-log", perm: "system:adjust_log" },
    ],
  },
  {
    label: "Finance",
    items: [
      { to: "/finance", label: "Purchasing & Finance", icon: Receipt, testid: "nav-finance", anyPerm: ["invoice:view", "freight:view", "bukku:view", "bukku:logs", "system:shipping_rates", "system:billing_companies"] },
      { to: "/cost-analysis", label: "Cost Analysis", icon: LineChart, testid: "nav-cost", perm: "system:cost_analysis" },
    ],
  },
  {
    label: "People",
    items: [
      { to: "/hr", label: "Human Resources", icon: Contact, testid: "nav-hr", anyPerm: ["hr:employee_view", "hr:import_autocount", "hr:schedule_view", "payroll_history:view", "attendance:view_team", "attendance:view_all", "leave:view_team", "leave:view_all", "leave:approve", "leave:balance_manage", "leave:type_manage", "leave:import_autocount"] },
      { to: "/my-schedule", label: "My Schedule", icon: CalendarClock, testid: "nav-my-schedule", perm: "schedule:view_own" },
      { to: "/my-attendance", label: "My Attendance", icon: Fingerprint, testid: "nav-my-attendance", perm: "attendance:view_own" },
      { to: "/my-leave", label: "My Leave", icon: CalendarCheck, testid: "nav-my-leave", perm: "leave:view_own" },
    ],
  },
  {
    label: "Marketplace",
    items: [
      { to: "/marketplace-orders", label: "Marketplace Orders", icon: ShoppingCart, testid: "nav-marketplace-orders", perm: "marketplace:view" },
      { to: "/marketplace-mappings", label: "Marketplace SKU Mapping", icon: Shuffle, testid: "nav-marketplace-mappings", perm: "marketplace:manage" },
      { to: "/marketplace-products", label: "Marketplace Products", icon: Package, testid: "nav-marketplace-products", perm: "marketplace:products_view" },
      { to: "/marketplace-reports", label: "Marketplace Reports", icon: BarChart3, testid: "nav-marketplace-reports", perm: "marketplace:reports_view" },
      { to: "/marketplace-erp", label: "Marketplace ERP", icon: PlugZap, testid: "nav-marketplace-erp", anyPerm: ["marketplace:fulfillment_view", "marketplace:returns_view", "marketplace:finance_view", "marketplace:cs_view"] },
      { to: "/marketplace-connections", label: "Marketplace Setup", icon: Link2, testid: "nav-marketplace-connections", perm: "marketplace:manage" },
    ],
  },
  {
    label: "Settings",
    items: [
      { to: "/integrations", label: "Integrations", icon: Plug, testid: "nav-integrations", anyPerm: ["integration:view"] },
      { to: "/users", label: "Users & Roles", icon: Users, testid: "nav-users", anyPerm: ["user:view", "role:view"] },
    ],
  },
];

// Flat list preserved for route access + landing resolution (unchanged behavior).
export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

export const itemAllowed = (item, can) =>
  item.perm ? can(item.perm) : item.anyPerm ? item.anyPerm.some(can) : true;

export const firstAccessible = (can) => {
  const hit = NAV_ITEMS.find((i) => itemAllowed(i, can));
  return hit ? hit.to : null;
};
